<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_PROCESANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <!-- OFICINAS -->
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "PRODUCTO.LBL_OFICINAS" | translate }}</label>
          <p-multiSelect
            id="idEstructuraFisica"
            name="nomEstructuraFisica"
            [options]="lisEstructurasFisica"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsEstructurasFisica"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsEstructurasFisica.invalid"
          >
            {{ "PRODUCTO.LBL_OFICINAS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- DESTINOS -->
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "PRODUCTO.LBL_DESTINOS" | translate }}</label>
          <p-multiSelect
            id="idDestino"
            name="nomDestino"
            [options]="lisDestinos"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsDestinos"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsDestinos.invalid"
          >
            {{ "PRODUCTO.LBL_DESTINOS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- SUBDESTINOS BLOQUEADOS -->
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label
            >* {{ "PRODUCTO.LBL_SUBDESTINOSBLOQUEADOS" | translate }}</label
          >
          <p-multiSelect
            id="idSubdestino"
            name="nomSubdestino"
            [options]="lisSubdestinos"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsSubdestinos"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsSubdestinos.invalid"
          >
            {{ "PRODUCTO.LBL_SUBDESTINOSBLOQUEADOS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- BOTON AGREGAR -->
      <div class="col-12 md:col-3 lg:col-3">
        <div *ngIf="!guardando">
          <button
            icon="fa fa-plus"
            label="{{ 'BTN_AGREGAR' | translate }}"
            type="submit"
            pButton
          ></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_GUARDANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <!-- TABLA -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        [loading]="guardando"
        [value]="lisProductosRestriccionesSubdestinos"
        selectionMode="single"
        dataKey="idProductosRestriccionesSubdestinos"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.estructuraFisica }}</td>
            <td>{{ row.destinoProducto }}</td>
            <td>{{ row.subdestinoProducto }}</td>
            <td class="text-center" *ngIf="!verDetalle">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhabilitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="text-center">
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
